import { styled } from '@mui/material/styles';
import { InputAdornment, TextField, Tooltip } from '@mui/material';
import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined';
import React, { useEffect, useState } from 'react';

const StyledPsdNumberField = styled(TextField)`
  outline: none;
  background-color: transparent;
`;

interface ValueFieldProps {
  inputRef?: React.Ref<HTMLInputElement> | undefined;
  autoFocus?: boolean;
  value?: unknown;
  placeholder?: string;
  error?: string | undefined;
  onKeyDown: React.KeyboardEventHandler<HTMLDivElement> | undefined;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export const PsdNumberField = ({
  inputRef,
  autoFocus,
  value,
  placeholder,
  error,
  onKeyDown,
  onChange,
}: ValueFieldProps) => {
  const formattedValue =
    value !== undefined && value !== null ? String(value) : '';
  const [inputValue, setInputValue] = useState(formattedValue);
  const [isEditing, setIsEditing] = useState(false);

  useEffect(() => {
    if (!isEditing || formattedValue === '') {
      setInputValue(formattedValue);
    }
  }, [formattedValue, isEditing]);

  return (
    <StyledPsdNumberField
      inputRef={inputRef}
      autoFocus={autoFocus}
      variant='standard'
      value={inputValue}
      placeholder={placeholder}
      slotProps={{
        htmlInput: {
          tabIndex: 0,
          inputMode: 'decimal',
          pattern: '-?[0-9]*([.,][0-9]+)?',
          title: '',
        },
        input: {
          disableUnderline: true,
          endAdornment: error && (
            <InputAdornment position='end'>
              <Tooltip title={error}>
                <ErrorOutlineOutlinedIcon
                  color={'error'}
                  sx={{ width: 20, height: 20 }}
                />
              </Tooltip>
            </InputAdornment>
          ),
          sx: {
            paddingX: '8px',
            paddingY: '2px',
          },
        },
      }}
      onKeyDown={onKeyDown}
      onFocus={() => setIsEditing(true)}
      onBlur={() => {
        setIsEditing(false);
        setInputValue(formattedValue);
      }}
      onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
        setInputValue(e.target.value);
        onChange(e);
      }}
    />
  );
};
